import React, { useState } from 'react'
import {
  Box,
  Tabs,
  Tab,
  Alert
} from '@mui/material'
import {
  Business as BusinessIcon,
  Payment as PaymentIcon,
  AccountBalance as AccountBalanceIcon,
  Assessment as AssessmentIcon
} from '@mui/icons-material'
import { useAuth } from '../contexts/AuthContext'
import { PageHeader } from '../components/ui'

// Import componentele existente
import BillingDashboard from './Billing/BillingDashboard'
import ContractsPage from './Billing/ContractsPage'
import ApprovalsPage from './Billing/ApprovalsPage'
import BillingReportsPage from './Billing/BillingReportsPage'
import TenantContractsTab from './Billing/TenantContractsTab'

const BillingPage: React.FC = () => {
  const { user } = useAuth()
  const [activeTab, setActiveTab] = useState(0)

  // Pentru medici - afișăm doar Dashboard-ul fără tab-uri
  if (user?.role === 'medic') {
    return (
      <Box>
        <PageHeader title="Billing & Facturare" />
        <BillingDashboard />
      </Box>
    )
  }

  // Pentru admin/operator - 4 taburi în ordine: Contracte Instituții, Contracte Medici, Aprobare Plăți, Rapoarte
  const adminTabs = [
    {
      label: 'Contracte Instituții',
      icon: <AccountBalanceIcon />,
      component: <TenantContractsTab />
    },
    {
      label: 'Contracte Medici',
      icon: <BusinessIcon />,
      component: <ContractsPage />
    },
    {
      label: 'Aprobare Plăți',
      icon: <PaymentIcon />,
      component: <ApprovalsPage />
    },
    {
      label: 'Rapoarte',
      icon: <AssessmentIcon />,
      component: <BillingReportsPage />
    }
  ]

  // Verifică permisiuni pentru admin/operator
  if (!user || !['admin', 'operator'].includes(user.role)) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          Nu aveți permisiuni pentru a accesa această secțiune.
        </Alert>
      </Box>
    )
  }

  // Tab-urile ca element pentru PageHeader - compact styling
  const tabsElement = (
    <Tabs 
      value={activeTab} 
      onChange={(_, newValue: number) => setActiveTab(newValue)}
      variant="scrollable"
      scrollButtons="auto"
      sx={{
        minHeight: 36,
        '& .MuiTab-root': {
          minHeight: 36,
          py: 0.5,
          px: 1.5,
          fontSize: '0.8rem',
          textTransform: 'none',
          '& .MuiSvgIcon-root': {
            fontSize: '1rem',
            mr: 0.5
          }
        }
      }}
    >
      {adminTabs.map((tab, index) => (
        <Tab
          key={index}
          icon={tab.icon}
          iconPosition="start"
          label={tab.label}
        />
      ))}
    </Tabs>
  )

  return (
    <Box>
      {/* Unified Page Header cu titlu și tab-uri */}
      <PageHeader
        title="Billing & Facturare"
        tabs={tabsElement}
      />

      {/* Content pentru tab-ul activ */}
      {adminTabs[activeTab]?.component}
    </Box>
  )
}

export default BillingPage
